import { render, staticRenderFns } from "./PersonalIdField.vue?vue&type=template&id=47505f08&"
import script from "./PersonalIdField.vue?vue&type=script&lang=js&"
export * from "./PersonalIdField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports